import React from "react";
import { NATION_TO_ISO } from "../utils/nations";

export default function Flag({ nation, className = "" }) {
  const code = NATION_TO_ISO[nation];
  if (!code) return null;
  return (
    <span
      className={`fi fi-${code} rounded-sm shrink-0 ${className}`}
      title={nation}
      aria-label={nation}
    />
  );
}

// Fills a round avatar slot with the player's flag (square variant, clipped to a circle
// by the parent's `rounded-full overflow-hidden`). Falls back to a silhouette.
export function PlayerFlag({ nation }) {
  const code = NATION_TO_ISO[nation];
  if (code) {
    return (
      <span
        className={`fi fis fi-${code}`}
        style={{ width: "100%", height: "100%", backgroundSize: "cover" }}
        title={nation}
        aria-label={nation}
      />
    );
  }
  return (
    <div className="w-full h-full grid place-items-center text-zinc-600">
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-1/2 h-1/2">
        <path d="M12 12a5 5 0 100-10 5 5 0 000 10zm0 2c-4.418 0-8 2.239-8 5v3h16v-3c0-2.761-3.582-5-8-5z" />
      </svg>
    </div>
  );
}
